jQuery(function($) {
  document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
	window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UQAKZ2']);
  });
  $('.back-in-stock-mini').on('click', function (){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'R5JWeS']);
  });
  $('.back-in-stock-standard').on('click', function (){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'YvKcAu']);
  });
  $('.back-in-stock-extended').on('click', function (){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RQxsCd']);
  });
  document.querySelector('.klaviyo_form_trigger_close').addEventListener('click', function (){
    document.querySelector('.klaviyo_form_trigger_wrapper').style.display = 'none';
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 1000*36000;
    now.setTime(expireTime);
    document.cookie = 'klaviyo_button=ok;expires='+now.toUTCString()+';path=/';
  });
  if (!!$.cookie('klaviyo_button')) {
    return;
  } else {
    $('.klaviyo_form_trigger_wrapper').addClass('show-button');
  }
});